/**
 * MUI CheckBox component that replaces the styled-components CheckBox
 * 
 * This component provides a Material UI equivalent of the original CheckBox component
 * with similar props and functionality.
 */
import React from 'react';
import { Checkbox as MuiCheckboxBase, FormControlLabel, styled } from '@mui/material';
import { CheckBoxProps } from 'types/components/molecules';

/**
 * MUI CheckBox component
 * 
 * @param props - Component props
 * @returns MUI CheckBox component
 */
const CheckBox: React.FC<CheckBoxProps> = (props) => {
  const { label, checked, onChange, disabled, color, size, indeterminate, isNav, ...otherProps } = props;
  
  return (
    <FormControlLabel
      control={
        <StyledCheckbox
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          color={color}
          size={size}
          indeterminate={indeterminate}
          {...otherProps}
        />
      }
      label={label}
      disabled={disabled}
    />
  );
};

// Styled MUI Checkbox component with prop filtering
const StyledCheckbox = styled(MuiCheckboxBase, {
  shouldForwardProp: (prop) => prop !== 'isNav',
})(({ theme }) => ({
  color: 'var(--app-gray)',
  '&.Mui-checked': {
    color: 'var(--app-red)',
  },
  '&.Mui-disabled': {
    color: 'var(--app-light-gray)',
  },
}));

export type { CheckBoxProps };
export default CheckBox;
